module.exports = __webpack_public_path__ + "media/images/prevention_form/alkohol-fb27818dc4582c9fe3369a0a89e26d6b.svg";